/**
 * external libs
 */
import React, {useContext, useEffect, useRef, useState} from 'react'
/**
 * components
 */
import CardsTable from "./components/CardsTable";
/**
 * styles
 */
import MedicalCardService from "../../services/medicalCard.service";
import FolderIdEnum from "../../enums/api/FolderId";
import {useLocation} from "react-router-dom";
import {AlertContext} from "../../pages/context/alert.context";
import {QueryString} from "../../utils/Querystring";
import MedicalCardModel from "../../model/medicalCard/medicalCard.model";
import Loader from "../Loader";
import axios from "axios";
import {GlobalFolderContext} from "../../pages/context/globalFolder.context";
import excludeMembersUtil from "../../utils/exludeMembers";

export default function CardPicker({perPage = 50, cardListSearch = "", pickerType, getSelectedCard = () => {}, setIsSearching = () => {}, emptyCard, initialMembers}) {
    const location = useLocation();
    const [medicalCard, setMedicalCard] = useState(null);
    const [excludeMembers, setExcludeMembers] = useState([]);
    const [isReady, setIsReady] = useState(false);
    const [closePaginate, setClosePaginate] = useState(false)
    const [isReadyPagination, setIsReadyPagination] = useState(false);
    const lastActiveRequest = useRef(null)
    const {setAlertError} = useContext(AlertContext)
    const {globalFolder} = useContext(GlobalFolderContext)
    const staticGlobalFolder = useRef(globalFolder);


    const getMedicalCard = async (params = {}) => {
        if (lastActiveRequest.current) {
            lastActiveRequest.current.cancel()
        }

        try {
            setIsSearching(true)
            const {search} = QueryString.parseQueryString(location.search);
            const searchRequestParamsValue = search || {};

            const {withPagination, ...requestParams} = params;
            if (!withPagination) {
                setIsReady(false)
            }

            setIsReadyPagination(false)

            const requestData = {
                limit: perPage + 1,
                offset: 0,
                exclude_members: ["8FB2C991-B8C2-EE11-AAB8-000C29E21A2A"],
                folder_id: staticGlobalFolder.current.id,
                ...searchRequestParamsValue,
                ...requestParams,
                "members": initialMembers,
                "include": "id,folder,holders,folder.id,folder.record,member,folder.included_members",
                "folder.depth": 0,
                "record.folders": [
                    {
                        id: FolderIdEnum.contacts,
                        children_depth: 0,
                        parents_depth: 0
                    },
                    ...(searchRequestParamsValue["record.folders"] || [])
                ],

            }

            if(cardListSearch){
                requestData.free_text = encodeURIComponent(cardListSearch);
            }

            lastActiveRequest.current = axios.CancelToken.source();

            const medCards = await MedicalCardService.list(requestData, lastActiveRequest.current.token)

            if (!medCards.length && !withPagination) {
                setMedicalCard([])
                return null
            }

            if(!medicalCard && emptyCard){
                medCards.unshift(new MedicalCardModel({
                    id: null
                }))
            }

            setExcludeMembers(excludeMembersUtil(staticGlobalFolder.current.included_members))
            setMedicalCard(!withPagination ? medCards : [...medicalCard, ...medCards])
            return medCards
        } catch (error) {
            if(error?.code !== "ERR_CANCELED"){
                setAlertError(error?.message);
            }
            return null
        } finally {
            setIsReady(true)
            setIsReadyPagination(true)
            setIsSearching(false)
        }
    };

    useEffect(() => {
        setMedicalCard(null)
        getMedicalCard()
            .then(medCards => {
                setClosePaginate(!medCards?.length || (medCards?.length <= perPage))
            })
    }, [cardListSearch])

    useEffect(() => {
        return () => {
            if (lastActiveRequest.current) {
                lastActiveRequest.current.cancel()
            }
        }
    }, [])

    if (!medicalCard) {
        return <Loader />
    }

    return (
        <CardsTable excludeMembers={excludeMembers}
                    getMedicalCard={getMedicalCard}
                    medicalCard={medicalCard}
                    getSelectedCard={getSelectedCard}
                    isReady={isReady}
                    closePaginate={closePaginate}
                    setClosePaginate={setClosePaginate}
                    pickerType={pickerType}
                    isReadyPagination={isReadyPagination}
                    cardFolderId={staticGlobalFolder.current?.id}
                    perPage={perPage}/>
    )
}
